export enum FetchPriority {
  Auto = 'auto',
  High = 'high',
}

export enum LoadingStrategy {
  Eager = 'eager',
  Lazy = 'lazy',
}
